import { Component, inject, input, InputSignal, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { NavigationComponent } from "../../components/common/navigation/navigation";
import { CertTabsComponent } from "../../components/cert/cert-tabs/cert-tabs";
import { CertHeaderComponent } from "../../components/cert/cert-header/cert-header";
import { DdosTabComponent } from "./components/ddos-tab/ddos-tab";
import { ScanTabComponent } from "./components/scan-tab/scan-tab";
import { FooterComponent } from "../../components/common/footer/footer";
import { DnsFirewallTabComponent } from "./components/dns-firewall-tab/dns-firewall-tab";
import { AIRT_SCANS_KEY, DDOS_FILTER_KEY, DNS_FIREWALL_KEY } from "../../components/cert/cert-tabs/cert-tabs.constants";

@Component({
  selector: "page-cert",
  templateUrl: "cert.html",
  styleUrls: ["cert.scss"],
  imports: [
    CertHeaderComponent,
    CertTabsComponent,
    DdosTabComponent,
    FooterComponent,
    NavigationComponent,
    ScanTabComponent,
    TranslateModule,
    DdosTabComponent,
    DnsFirewallTabComponent,
  ],
})
export class CertPage implements OnInit {
  private router = inject(Router);

  protected keys = {
    AIRT: AIRT_SCANS_KEY,
    DDOS: DDOS_FILTER_KEY,
    DNS: DNS_FIREWALL_KEY,
  };

  // this value is read from the URL (see dashboard-routing.module.ts)
  // Setting a default string does not work, because if `:initialTab` is absent in the URL,
  // the signal defaults to undefined
  readonly initialTab: InputSignal<string | undefined> = input(undefined);
  public activeTab = AIRT_SCANS_KEY;

  ngOnInit() {
    const init = this.initialTab();
    const validTab = [AIRT_SCANS_KEY, DDOS_FILTER_KEY, DNS_FIREWALL_KEY].includes(init?.toLowerCase());
    this.activeTab = validTab ? init : AIRT_SCANS_KEY;
  }

  changeTab(tab: string) {
    this.router.navigate(["/cert", tab], { replaceUrl: true });
    this.activeTab = tab;
  }
}
